module.exports = __webpack_public_path__ + "img/logo-1.293d0f9c.png";